import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { lazy, Suspense } from 'react';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';
const LoadableRedux = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "adopts_seller_shared" */ './redux/SellerModuleLoader')));
const LoadableSingleSellModal = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "adopts_seller_shared" */ './SingularSellerModal')));
const LoadableBatchSellModal = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "adopts_seller_shared" */ './BatchSellerModal')));
const SellerModalLoadable = (_param)=>{
    var { deviations } = _param, rest = _object_without_properties(_param, [
        "deviations"
    ]);
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "SellerModalLoadable"
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(LoadingIndicator, {
            view: 'llama',
            withOverlay: true,
            usePortal: true
        })
    }, /*#__PURE__*/ React.createElement(LoadableRedux, null), deviations.length === 1 ? /*#__PURE__*/ React.createElement(LoadableSingleSellModal, _object_spread({
        deviation: deviations[0]
    }, rest)) : /*#__PURE__*/ React.createElement(LoadableBatchSellModal, _object_spread({
        deviations: deviations
    }, rest))));
};
SellerModalLoadable.displayName = 'SellerModalLoadable';
export default SellerModalLoadable;

//# sourceMappingURL=SellerModalLoadable.js.map